import { render } from "./StudentUserList.vue?vue&type=template&id=3bd91842&scoped=true"
import script from "./StudentUserList.vue?vue&type=script&lang=js"
export * from "./StudentUserList.vue?vue&type=script&lang=js"

import "./StudentUserList.vue?vue&type=style&index=0&id=3bd91842&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd91842"]])

export default __exports__